import Vue from 'vue';
import 'whatwg-fetch';
import VueI18n from 'vue-i18n';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import pl from '@/trans/pl.json';
import en from '@/trans/en.json';
import fr from '@/trans/fr.json';
import es from '@/trans/es.json';
import App from './App.vue';

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        Vue,
        dsn: 'https://bb1439f705594e0e89434ef104e51bbc@o522645.ingest.sentry.io/4504876001067008',
        integrations: [new BrowserTracing()],
        tracesSampleRate: 0.1,
    });
}

Vue.config.productionTip = false;
Vue.use(VueI18n);

const i18n = new VueI18n({
    messages: {
        en, pl, fr, es,
    },
    locale: Intl.DateTimeFormat().resolvedOptions().locale.slice(0, 2)
    || navigator.language.slice(0, 2),
});

new Vue({
    i18n,
    render: (h) => h(App),
}).$mount('#app');
